import PropTypes from "prop-types";
import { SDP_HERO_TEXT_ALIGN } from "app/constants";
import "./SmartDPMarketingHeadline.scss";
import { memo } from "react";
import { messagePropType } from "app/utils/propTypes";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import CustomFormattedMessageContainer, {
	DISPLAY_OPTIONS,
} from "app/pages/.shared/CustomFormattedMessage/CustomFormattedMessageContainer";
import AmountContainer from "app/pages/.shared/AmountContainer";
import { FormattedMessage } from "react-intl";

const SmartDPMarketingHeadline = ({
	title,
	subtitle,
	textAlign,
	lowestPrice,
	hideSubtitle = false,
	displayLowestPrice,
	onClick = () => {},
}) => {
	let align = "center";
	if (textAlign === SDP_HERO_TEXT_ALIGN.LEFT) {
		align = "flex-start";
	} else if (textAlign === SDP_HERO_TEXT_ALIGN.RIGHT) {
		align = "flex-end";
	}

	return (
		<h1
			className="smartdp-marketing-headline"
			style={{
				alignItems: align,
			}}
			onClick={onClick}
		>
			{title && (
				<>
					<Typography
						variant={TYPOGRAPHY_VARIANTS.XL6}
						variantSM={TYPOGRAPHY_VARIANTS.XL6}
						variantMD={TYPOGRAPHY_VARIANTS.XL8}
						variantLG={TYPOGRAPHY_VARIANTS.XL9}
						isBold
						className="smartdp-marketing-headline__title"
						component="div"
					>
						<CustomFormattedMessageContainer
							displayOptions={{
								[DISPLAY_OPTIONS.CALL_PRICE]: !displayLowestPrice,
							}}
							message={title}
							lowestPrice={lowestPrice}
							enableHTMLFormatting={true}
						/>
					</Typography>
				</>
			)}{" "}
			{/* keep this space for H1 title and subtitle being separated*/}
			{subtitle && !hideSubtitle && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.REGULAR}
					variantMD={TYPOGRAPHY_VARIANTS.XL3}
					isBold
					className="smartdp-marketing-headline__subtitle"
					component="div"
				>
					<CustomFormattedMessageContainer
						displayOptions={{
							[DISPLAY_OPTIONS.CALL_PRICE]: !displayLowestPrice,
						}}
						message={subtitle}
						lowestPrice={lowestPrice}
						enableHTMLFormatting={true}
					/>{" "}
					{/* keep the space for H1 title and subtitle being separated*/}
					{displayLowestPrice && (
						<AmountContainer
							amount={lowestPrice}
							prefix={<FormattedMessage id="general.from.label" />}
							suffix={
								<FormattedMessage id="general.amount.per.person.suffix.label.short" />
							}
						/>
					)}
				</Typography>
			)}
		</h1>
	);
};

SmartDPMarketingHeadline.propTypes = {
	title: messagePropType,
	subtitle: messagePropType,
	lowestPrice: PropTypes.number,
	textAlign: PropTypes.string,
	hideSubtitle: PropTypes.bool,
	displayLowestPrice: PropTypes.string,
	onClick: PropTypes.func,
};

export default memo(SmartDPMarketingHeadline);
